import { Component, OnInit } from '@angular/core';

import { ModalClosedReason, ModalContent } from '@ap/modal';
import { ApContentService } from '@ap/content';

import content from './browser-outdated-modal.content.json';

/**
 * @module IEModalModule
 * @ngdoc component
 * @name IEModalComponent
 */
@Component({
    selector: 'browser-outdated-modal',
    templateUrl: 'browser-outdated-modal.component.html',
    standalone: false
})
export class BrowserOutdatedModalComponent extends ModalContent<void> implements OnInit {
    public constructor(private readonly contentService: ApContentService) {
        super();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public toBrowserInfo(): void {
        this.close(ModalClosedReason.ACCEPTED);
    }

    public toLogin(): void {
        this.close(ModalClosedReason.DECLINED);
    }
}
